import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import installHttp from "./vue-axios";
import { exposeStoreToGa4Overlay, exposeDatePickerToGa4Overlay } from "./utils/ga4Bridge";
import { installImageLoading } from "./utils/imageLoading";

// css
import "@/assets/styles/design-tokens.css";
import "@/assets/styles/themes.css";
import "@/assets/styles/ops.css";
import "@/assets/styles/styles.css";
import "@/assets/styles/dark.css";

import store from "./store";
import i18n from "./i18n";

import Loader from "@/widgets/Loader";
import Notification from "@/widgets/Notification";
import ModalBox from "@/widgets/ModalBox";
import AppIcon from "@/components/icons/AppIcon";

// Shared UI library (src/ui). Registered globally so a page never has to
// import, register and remember a component that every page uses.
import BrandMark from "@/ui/BrandMark";
import SparkLine from "@/ui/SparkLine";
import StatusBadge from "@/ui/StatusBadge";
import ReasonConfirm from "@/ui/ReasonConfirm";
import StatCard from "@/ui/StatCard";
import AreaChart from "@/ui/AreaChart";
import DotGrid from "@/ui/DotGrid";
import SkeletonBlock from "@/ui/SkeletonBlock";
import DateTimeInput from "@/ui/DateTimeInput";
import DatePicker from "@/ui/DatePicker";
import PageHeader from "@/ui/PageHeader";

import "@/assets/styles/flaticon.css";
import "@/assets/styles/base.css";
import "@/assets/styles/_forms.css";
// Last, so the shared surfaces (cards, KPI tiles, chips, tables) win over the older generic rules.
import "@/assets/styles/surfaces.css";

// Image cropper: vue-croppa 1.3.8 carried over to Vue 3 (src/ui/croppa).
import "@/ui/croppa/croppa.css";
import Croppa from "@/ui/croppa";

// <money>: v-money's behavior on Vue 3 (src/ui/MoneyInput.vue).
import MoneyInput from "@/ui/MoneyInput";

const app = createApp(App);

app.use(store);
app.use(router);
// English or Turkish ($tr; the top bar switches it).
app.use(i18n);
installHttp(app);
// Before mounting, so the first pictures a page shows are covered too.
installImageLoading();

app.component("Loader", Loader);
app.component("Notification", Notification);
app.component("ModalBox", ModalBox);
app.component("AppIcon", AppIcon);
app.component("BrandMark", BrandMark);
app.component("SparkLine", SparkLine);
app.component("StatusBadge", StatusBadge);
app.component("ReasonConfirm", ReasonConfirm);
app.component("StatCard", StatCard);
app.component("AreaChart", AreaChart);
app.component("DotGrid", DotGrid);
app.component("SkeletonBlock", SkeletonBlock);
app.component("PageHeader", PageHeader);
app.component("DateTimeInput", DateTimeInput);
app.component("DatePicker", DatePicker);
app.component("croppa", Croppa);
app.component("money", MoneyInput);

const root = document.getElementById("app");
app.mount(root);
// The calendar first: the overlay mounts once it finds the store, and then uses it.
exposeDatePickerToGa4Overlay(DatePicker);
exposeStoreToGa4Overlay(root, store);
